import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import BrandsComparisionDetail from "./BrandsComparisionDetail";

class BrandsTripleComparisionPersona extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  resize = (arr, newSize, defaultValue) => {
    const newArray = arr;
    while (newSize > arr.length) arr.push(defaultValue);
    newArray.length = newSize;
  }

  fill(brandsOrMedia) {
    if (brandsOrMedia.length < 10) {
      this.resize(brandsOrMedia, 10, {
        brandCategory: 'N/A',
        brandLabel: 'N/A',
        icon: 'clear-field-icon_190-190-190.png',
        index: 'N/A',
        weighted: 'N/A',
        sample: 'N/A',
        pct: 'N/A',
      });
    }
    return brandsOrMedia;
  }

  render() {
    let brandsList = [];
    if (this.props.brands !== undefined) {
      brandsList = this.props.brands;
    }

    return (
      <div className="row fullwidth brandsCardPdf">
        <div className="row fullwidth demographic-detail-columns brandsTriplePersonaPdf">
          {!_.isEmpty(brandsList) &&
            brandsList.length > 0 &&
            brandsList.map((brand, index) => (<div key={index}>
              <div className="columns large-4 medium-4 small-4">
                {this.fill(brand.brandList.slice(0, 10)).map(
                  (brandDetail, i) => (<div
                    className="row fullwidth demographic-detail-columns"
                    key={`brand-t${index}${i}`}
                  >
                    <div className="columns large-12 small-12 medium-12">
                        <BrandsComparisionDetail
                          key={i}
                          brandCategory={brandDetail.brandCategory}
                          statement={brandDetail.brandLabel}
                          brandDetail={brandDetail}
                          personaIndex={index}
                          selectedTab={this.props.selectedTab}
                          selectedIcon={_.camelCase(
                            brandDetail.icon.replace('.png', ''),
                          )}
                        />
                    </div>
                  </div>
                  ),
                )}
              </div>
            </div>
            )
            )}
        </div>
      </div>
    );
  }
}

BrandsTripleComparisionPersona.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.object),
  selectedTab: PropTypes.string,
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(BrandsTripleComparisionPersona);
